// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__dZrcD","modalFooterButton":"ModalNotes_modalFooterButton__2nOUP"};